import { render, staticRenderFns } from "./PlayerBottomBar.vue?vue&type=template&id=7cd9b0d2&"
import script from "./PlayerBottomBar.vue?vue&type=script&lang=js&"
export * from "./PlayerBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBottomBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports